import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import stats from './statsPage/handler';
import settings from './settingsPage/handler';

export default pipeHandlers(common, stats, settings);
